module.exports = __webpack_public_path__ + "static/media/conference_des_financeurs.bbc5c249.jpg";